import { AfterViewInit, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { Telegram } from '@twa-dev/types';
import { environment } from "../environments/environment";
import { NavigationHistoryService } from "./modules/fraud/partials/services/navigation-history.service";
import { Subscription } from 'rxjs';
import { ProjectSettingsService } from './modules/fraud/partials/services/project-settings.service';

declare global {
  interface Window {
    Telegram: Telegram;
  }
}

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  public readonly projectSettingsService: ProjectSettingsService = inject(ProjectSettingsService);
  private routerSubscription?: Subscription;

  constructor(private router: Router) {
    inject(NavigationHistoryService);
  }

  get hasDarkTheme(): boolean {
    return environment.hasDarkTheme;
  }

  ngAfterViewInit(): void {
    this._expandWindowTelegram();
  }

  ngOnInit(): void {
    if (this.hasDarkTheme) {
      const isDarkTheme = JSON.parse(localStorage.getItem('isDarkTheme') ?? 'false');

      document.body.classList.remove('dark', 'light');
      document.body.classList.add(isDarkTheme ? 'dark' : 'light');

      document.documentElement.classList.remove('dark', 'light');
      document.documentElement.classList.add(isDarkTheme ? 'dark' : 'light');
    } else {
      document.body.classList.add('light');
      document.documentElement.classList.add('light');
    }
    this.projectSettingsService.load();

    // Слушаем изменения роутов
    // this.routerSubscription = this.router.events.subscribe(event => {
    //   if (event instanceof NavigationStart) {
    //     console.log('🚀 Navigation Start:', {
    //       url: event.url,
    //       navigationId: event.id,
    //       navigationTrigger: event.navigationTrigger
    //     });
    //   } else if (event instanceof NavigationEnd) {
    //     const wasRedirected = event.url !== event.urlAfterRedirects;
    //     console.log('✅ Navigation End (Success):', {
    //       url: event.url,
    //       urlAfterRedirects: event.urlAfterRedirects,
    //       wasRedirected: wasRedirected,
    //       navigationId: event.id
    //     });
        
    //     if (wasRedirected) {
    //       console.log('🔄 Redirect detected:', {
    //         from: event.url,
    //         to: event.urlAfterRedirects
    //       });
    //     }
    //   } else if (event instanceof NavigationCancel) {
    //     console.log('❌ Navigation Canceled:', {
    //       url: event.url,
    //       reason: event.reason,
    //       navigationId: event.id
    //     });
    //   } else if (event instanceof NavigationError) {
    //     console.log('⚠️ Navigation Error:', {
    //       url: event.url,
    //       error: event.error,
    //       navigationId: event.id
    //     });
    //   }
    // });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private _expandWindowTelegram(): void {
    window.Telegram.WebApp.expand();
  }
}
